import React, { Component } from "react";
import rjson from "relaxed-json";
import Dropzone from "react-dropzone";
import Toast from "react-bootstrap/Toast";
import Spinner from "react-bootstrap/Spinner";
import superagent from "superagent";
import "./admin.css";

export default class AdminFileLoader extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fileName: null,
    };
  }

  getUrlQueryParameters(queryString) {
    var match,
      pl = /\+/g, // Regex for replacing addition symbol with a space
      search = /([^&=]+)=?([^&]*)/g,
      decode = function (s) {
        return decodeURIComponent(s.replace(pl, " "));
      },
      query = queryString.substring(1);

    var urlParams = {};
    while ((match = search.exec(query))) {
      let value = decode(match[2]);
      value = this.fixStringBoolean(value);
      urlParams[decode(match[1])] = value;
    }

    return urlParams;
  }

  fixStringBoolean = (value) => {
    if (value == null) return null;
    var loweredValue = value.toLowerCase();
    return loweredValue === "true"
      ? true
      : loweredValue === "false"
      ? false
      : value;
  };

  extractSettings = (fileName, jsonContent) => {
    let urlQueryParams = this.getUrlQueryParameters(jsonContent.urlQuery);
    this.setState({
      fileName,
    });
    this.raiseOnFileLoaded(fileName, jsonContent, {
      ...jsonContent,
      urlQuery: { ...urlQueryParams },
    });
  };

  onFileChangeHandler = (event) => {
    var file = event.target.files[0];
    this.processFile(file);
  };

  onFilesSelected = (files) => {
    var file = files[0];
    this.processFile(file);
  };

  readFromClipboard = (e) => {
    navigator.clipboard
      .readText()
      .then((text) => {
        console.log("Pasted content: ", text);
        this.processContent(text);
      })
      .catch((err) => {
        console.error("Failed to read clipboard contents: ", err);
        this.raiseOnFileException(err);
      });
    e.preventDefault();
  };

  processFile = (file) => {
    if (file) {
      let reader = new FileReader();

      reader.readAsText(file);

      var that = this;
      reader.onload = function () {
        try {
          var content = reader.result;
          console.log(content);
          var fixedContent = rjson.transform(content);
          var jsonContent = JSON.parse(fixedContent);
          console.log(jsonContent);
          that.extractSettings(file.name, jsonContent);
        } catch (e) {
          (console.error || console.log).call(console, e.stack || e);
          that.raiseOnFileException(e);
        }
      };

      reader.onerror = function () {
        console.log(reader.error);
        that.raiseOnFileException(reader.error);
      };
    }
  };

  processContent = (content) => {
    if (content) {
      try {
        console.log(content);
        var fixedContent = rjson.transform(content);
        var jsonContent = JSON.parse(fixedContent);
        console.log(jsonContent);
        var d = new Date();

        var fileName =
          d.getFullYear().toString().substr(-2) +
          "_" +
          ("0" + (d.getMonth() + 1)).slice(-2) +
          "_" +
          ("0" + d.getDate()).slice(-2) +
          "_" +
          jsonContent.orderId +
          ".txt";

        this.extractSettings(fileName, jsonContent);
      } catch (e) {
        (console.error || console.log).call(console, e.stack || e);
        this.raiseOnFileException(e);
      }
    }
  };

  raiseOnFileLoaded = (fileName, file, settings) => {
    this.props.onFileLoaded(fileName, file, settings);
  };

  raiseOnFileException = (message) => {
    this.props.onFileException(message);
  };

  render() {
    return (
      <Dropzone
        onDrop={this.onFilesSelected}
        multiple={false}
        accept=".txt"
        noClick={true}
      >
        {({
          getRootProps,
          getInputProps,
          isDragActive,
          isDragAccept,
          open,
        }) => (
          <section
            className={
              "react-dropzone-styled " +
              (isDragActive ? "react-dropzone-styled-active" : "")
            }
          >
            <div {...getRootProps()}>
              <svg
                className="box__icon"
                xmlns="http://www.w3.org/2000/svg"
                width="50"
                height="43"
                viewBox="0 0 50 43"
              >
                <path d="M48.4 26.5c-.9 0-1.7.7-1.7 1.7v11.6h-43.3v-11.6c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v13.2c0 .9.7 1.7 1.7 1.7h46.7c.9 0 1.7-.7 1.7-1.7v-13.2c0-1-.7-1.7-1.7-1.7zm-24.5 6.1c.3.3.8.5 1.2.5.4 0 .9-.2 1.2-.5l10-11.6c.7-.7.7-1.7 0-2.4s-1.7-.7-2.4 0l-7.1 8.3v-25.3c0-.9-.7-1.7-1.7-1.7s-1.7.7-1.7 1.7v25.3l-7.1-8.3c-.7-.7-1.7-.7-2.4 0s-.7 1.7 0 2.4l10 11.6z"></path>
              </svg>
              <input {...getInputProps()} id="file" />
              <strong>Перетащите файл сюда</strong>
              <span> или</span>
              <p>{this.state.fileName}</p>
              <button
                className="btn u-btn-primary g-font-size-13 g-py-10 mt-1"
                onClick={open}
              >
                Выбрать файл
              </button>
              <button
                className="btn u-btn-primary g-font-size-13 g-py-10 ml-1 mt-1"
                onClick={this.readFromClipboard}
              >
                Вставить скопированный текст
              </button>
            </div>
          </section>
        )}
      </Dropzone>
    );
  }
}
